export default function getResource(label) {
    const resources = {
        noSamplesInStock: 'There are no samples in stock at this time.'
    };

    return resources[label];
}
